import "./title.css";

const Title = () => {
  return (
    <div className="title">
      <p>Your Todish ✨</p>
    </div>
  );
};
export default Title;
